<template>
  <div
    :class="[
      'bg',
      {
        'bg-guest': !userTokenAvailable,
        'logged-in': userTokenAvailable && !isMobile,
        'not-logged-in': !userTokenAvailable && isMobile,
        collapsed: this.$root.isCollapsed && !isMobile,
        notification:
          userTokenAvailable &&
          this.$root.warning &&
          this.$root.warning !== 'NORMAL' &&
          !isMobile,
      },
    ]"
  >
    <div class="loader-wrapper" v-if="isLoading">
      <LoaderAnimation />
      <div
        style="
          font-size: 14px;
          margin-top: 30px;
          color: #2e5ba7;
          font-weight: 600;
        "
      >
        {{ $t("please-wait") }} <br />
        {{ $t("your-order") }}
      </div>
    </div>
    <div
      :class="['modal', { 'modal-notloggedin': !userTokenAvailable }]"
      v-else
    >
      <div class="frame-35654">
        <div class="wrapper-class-2">
          <div class="wrapper-class">
            <div class="back-button" @click="goBack" v-if="userTokenAvailable">
              <i class="fa-solid fa-angle-left" style="margin-right: 10px"></i>
              {{ isPiFlow ? $t("place-order") : $t("search") }}
            </div>
            <div class="company-info-wrapper">
              <div class="frame-35656">
                <div class="frame-35655">
                  <div class="company-name">{{ $t("entity-name") }}</div>
                  <div class="yoki-biodiesel-private-limited">
                    {{ selectedCompanyName.toLowerCase() }}
                  </div>
                </div>
                <div class="frame-35662">
                  <div class="classification">{{ $t("entity-type") }}</div>
                  <div
                    v-if="
                      clickedSearchResult?.additional_info?.more_information
                        ?.company_classification ||
                      clickedSearchResult?.additional_info?.more_information
                        ?.company_type
                    "
                    class="private-limited-company"
                  >
                    {{
                      clickedSearchResult?.additional_info?.more_information
                        ?.company_classification ||
                      clickedSearchResult?.additional_info?.more_information
                        ?.company_type
                    }}
                  </div>
                  <div
                    v-else
                    class="private-limited-company"
                    style="width: fit-content"
                  >
                    <Dropdown :triggers="['hover']" :autoHide="true">
                      <div class="overlay">
                        <i class="fas fa-lock lock-icon"></i>
                      </div>
                      <template #popper>
                        <div
                          class="default-tooltip-message"
                          style="font-size: 12px"
                        >
                          {{ $t("please-order") }}
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                </div>
                <div
                  v-if="
                    clickedSearchResult?.additional_info
                      ?.company_identifiers?.[0]?.value &&
                    !productVariant?.availableAddresses?.[0]?.registered_address
                      ?.full_address &&
                    clickedSearchResult?.additional_info
                      ?.company_identifiers?.[0]?.name !== 'WIN'
                  "
                  class="frame-35659"
                >
                  <div class="cin-identifiers">
                    {{ $t("identifiers") }} ({{
                      clickedSearchResult?.additional_info
                        ?.company_identifiers?.[0]?.name
                    }})
                  </div>
                  <div class="u-24299-mh-2021-ptv-372774">
                    {{
                      clickedSearchResult?.additional_info
                        ?.company_identifiers?.[0]?.value
                    }}
                  </div>
                </div>
                <div
                  v-if="clickedSearchResult?.additional_info?.company_status"
                  class="frame-35660"
                >
                  <div class="status">{{ $t("status") }}</div>
                  <div class="active">
                    {{
                      clickedSearchResult.additional_info.company_status.toLowerCase()
                    }}
                  </div>
                </div>
                <div class="frame-35663">
                  <div class="year-of-incorporation">{{ $t("year-of") }}</div>
                  <div
                    v-if="
                      clickedSearchResult?.additional_info?.more_information
                        ?.year_of_incorporation
                    "
                    class="_2021"
                  >
                    {{
                      clickedSearchResult?.additional_info?.more_information
                        ?.year_of_incorporation
                    }}
                  </div>
                  <div v-else class="_2021" style="width: fit-content">
                    <Dropdown :triggers="['hover']" :autoHide="true">
                      <div>
                        <i class="fas fa-lock lock-icon"></i>
                      </div>
                      <template #popper>
                        <div
                          class="default-tooltip-message"
                          style="font-size: 12px"
                        >
                          {{ $t("please-order") }}
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                </div>
                <div
                  v-if="
                    clickedSearchResult?.additional_info
                      ?.company_identifiers?.[0]?.value &&
                    productVariant?.availableAddresses?.[0]?.registered_address
                      ?.full_address &&
                    clickedSearchResult?.additional_info
                      ?.company_identifiers?.[0]?.name !== 'WIN'
                  "
                  class="frame-35659"
                >
                  <div class="cin-identifiers">
                    {{ $t("identifiers") }} ({{
                      clickedSearchResult?.additional_info
                        ?.company_identifiers?.[0]?.name
                    }})
                  </div>
                  <div class="u-24299-mh-2021-ptv-372774">
                    {{
                      clickedSearchResult?.additional_info
                        ?.company_identifiers?.[0]?.value
                    }}
                  </div>
                </div>
              </div>
              <div class="frame-356572">
                <div
                  class="frame-35662"
                  v-if="
                    clickedSearchResult?.additional_info &&
                    Object.prototype.hasOwnProperty.call(
                      clickedSearchResult?.additional_info,
                      'company_address'
                    )
                  "
                >
                  <div class="classification">{{ $t("address") }}</div>
                  <div class="private-limited-company">
                    {{
                      clickedSearchResult?.additional_info?.company_address.toLowerCase()
                    }}
                  </div>
                </div>
                <div
                  class="frame-35662"
                  v-if="
                    productVariant?.availableAddresses?.[0]?.registered_address
                      ?.full_address ||
                    clickedSearchResult?.additional_info?.registered_address
                  "
                >
                  <div class="classification">{{ $t("reg-address") }}</div>
                  <div class="private-limited-company">
                    {{
                      productVariant?.availableAddresses?.[0]?.registered_address?.full_address.toLowerCase() ||
                      clickedSearchResult?.additional_info?.registered_address.toLowerCase()
                    }}
                  </div>
                </div>
                <div
                  class="frame-35662"
                  v-if="clickedSearchResult?.additional_info?.business_address"
                >
                  <div class="classification">{{ $t("bus-address") }}</div>
                  <div class="private-limited-company">
                    {{
                      clickedSearchResult?.additional_info?.business_address.toLowerCase()
                    }}
                  </div>
                </div>
                <div
                  class="frame-35662"
                  v-if="clickedSearchResult?.additional_info?.more_addresses"
                >
                  <div class="classification">{{ $t("more-address") }}</div>
                  <ul
                    style="margin: 0; width: 100%; padding-inline-start: 30px"
                  >
                    <li
                      v-for="(address, index) in clickedSearchResult
                        .additional_info.more_addresses"
                      :key="index"
                      style="list-style-type: disc !important"
                    >
                      <div class="private-limited-company">
                        {{ address.toLowerCase() }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="lock-note"
              style="
                padding: 10px;
                border-radius: 16px;
                text-transform: none;
                background-color: aliceblue;
                background: linear-gradient(0deg, #f3f5f8 0%, #f3f5f8 100%),
                  #e7ebf0;
                box-shadow: -4px -4px 8px 0px #fff,
                  4px 4px 8px 0px rgba(0, 0, 0, 0.25);
              "
              v-if="
                !clickedSearchResult?.additional_info?.more_information
                  ?.company_classification &&
                !clickedSearchResult?.additional_info?.more_information
                  ?.company_type &&
                !clickedSearchResult?.additional_info?.more_information
                  ?.year_of_incorporation
              "
            >
              <i class="fas fa-lock lock-icon"></i> - {{ $t("this-info") }}
              <a
                href="/contact"
                style="color: #224096; cursor: pointer; font-weight: 600"
                >{{ $t("contactus") }}</a
              >
              {{ $t("any-questions") }}
            </div>
            <div class="notes">
              <div class="note-title">
                <span>
                  <span style="font-weight: 600">{{ $t("note") }}: </span>
                  <span class="note-text">
                    {{ $t("please-note") }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="frame-35653">
            <div class="frame-35652">
              <div class="user-details-wrapper-address">
                <div class="input-sections">
                  <div class="input-field-title">
                    {{ $t("if-diff") }}
                  </div>
                  <div class="frame-3" id="address-field">
                    <textarea
                      class="enter-email-address"
                      :placeholder="`${$t('enter-add')}`"
                      v-model.trim="additionalAddress"
                    ></textarea>
                  </div>
                </div>
                <div class="input-sections1">
                  <div class="input-field-title">{{ $t("cust-name") }}</div>
                  <div class="input-group">
                    <input
                      type="text"
                      v-model.trim="name"
                      :placeholder="
                        windowWidth <= 1156
                          ? $t('cust-name')
                          : $t('your-cust-name')
                      "
                      required
                    />
                  </div>
                  <div class="ref-wrapper">
                    <div class="input-field-title">{{ $t("ref-no") }}</div>
                    <div class="input-group">
                      <input
                        type="text"
                        :placeholder="`${$t('ref-no')}`"
                        v-model.trim="referenceNumber"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="user-details-wrapper">
                <div class="input-sections1" v-if="isPiFlow">
                  <div class="input-field-title">{{ $t("phone") }}</div>
                  <div class="input-group">
                  <input
                    type="tel"
                    v-model.trim="phone"
                    :placeholder="`${$t('phone')}`"
                    required
                  />
                </div>
                </div>
                <div class="input-sections1" v-else>
                  <div class="input-field-title">{{ $t("phone") }}</div>
                  <div class="input-group phone-input">
                    <select
                      v-model="selectedCountryCode"
                      class="country-dropdown"
                    >
                      <option value="" disabled>
                        {{ $t("select-country") }}
                      </option>
                      <option
                        v-for="country in countries"
                        :value="country"
                        :key="country.code"
                        class="country-option"
                      >
                        {{ country.name }} - (+{{
                          getFirstDialCode(country?.dialCode)
                        }})
                      </option>
                    </select>
                    <input
                      type="tel"
                      v-model.trim="phone"
                      :placeholder="`${$t('phone')}`"
                      style="width: 70%; border: none; outline: none"
                      inputmode="tel"
                      autocomplete="tel"
                      required
                      pattern="[0-9()+\()-]*"
                    />
                  </div>
                </div>
                <div class="input-sections1">
                  <div class="input-field-title">{{ $t("landline") }}</div>
                  <div class="input-group phone-input">
                    <input
                      type="tel"
                      v-model.trim="areaCode"
                      :placeholder="`${$t('area-code')}`"
                      style="
                        width: 30%;
                        outline: none;
                        border-left: none;
                        border-top: none;
                        border-bottom: none;
                        border-right: 1ps solid rgba(87, 87, 87, 0.5);
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                      "
                      inputmode="tel"
                      autocomplete="tel"
                      required
                      maxlength="8"
                      pattern="[0-9()+\()-]*"
                    />
                    <input
                      type="tel"
                      v-model.trim="landline"
                      :placeholder="`${$t('enter-landline')}`"
                      style="width: 70%; border: none; outline: none"
                      inputmode="tel"
                      autocomplete="tel"
                      required
                      maxlength="25"
                      pattern="[0-9()+\()-]*"
                    />
                  </div>
                </div>
              </div>
              <div
                class="user-details-wrapper"
                style="width: 100%"
                v-if="userType == null"
              >
                <div
                  class="input-group1"
                  style="
                    gap: 10px;
                    justify-content: space-between;
                    border-radius: 13px;
                  "
                >
                  <div class="input-field-title">
                    {{ $t("deliver-to") }} <span style="color: red">*</span>
                  </div>
                  <input
                    style="width: auto"
                    type="text"
                    v-model="deliveryEmail"
                    @change="
                      createButtonDisabled ? none : toggleConfirmDeliveryEmail
                    "
                    :placeholder="
                      email == null ? $t('enter-delivery-email') : `${email}`
                    "
                    required
                  />
                </div>
                <div
                  class="input-group1"
                  style="
                    gap: 10px;
                    justify-content: space-between;
                    border-radius: 13px;
                  "
                >
                  <div class="input-field-title">
                    {{ $t("confirm-email") }} <span style="color: red">*</span>
                  </div>
                  <input
                    :class="{ shake: shakeConfirmEmail }"
                    :style="{
                      width: 'auto',
                      border: toggleConfirmDeliveryEmailBorder,
                    }"
                    type="text"
                    v-model="confirmDeliveryEmail"
                    @change="
                      createButtonDisabled ? none : toggleConfirmDeliveryEmail
                    "
                    :placeholder="`${$t('re-enter')}`"
                    required
                  />
                </div>
              </div>
              <div class="user-details-wrapper" v-if="entityType === 'BANK'">
                <div class="input-sections1">
                  <div class="input-field-title">
                    {{ $t("branch-name") }} <span style="color: red">*</span>
                  </div>
                  <select
                    v-model="BranchName"
                    class="input-field dropdown-1"
                    :style="{
                      color: BranchName === null ? '#757575' : '#000001',
                    }"
                  >
                    <option value="null" disabled>
                      {{
                        branchList === null
                          ? $t("no-branch")
                          : $t("select-branch")
                      }}
                    </option>
                    <option
                      v-for="(branchDetails, index) in branchList"
                      :value="branchDetails.branchName"
                      :key="index"
                      class="country-option"
                    >
                      {{ branchDetails?.branchName }}
                    </option>
                    <option value="Other" class="country-option">
                      {{ $t("other") }}
                    </option>
                  </select>
                </div>
                <div class="input-sections1" v-if="BranchName === 'Other'">
                  <div class="input-field-title">
                    {{ $t("other-branch-name") }}
                    <span style="color: red">*</span>
                  </div>
                  <div class="input-group">
                    <input
                      type="text"
                      v-model.trim="otherBranchName"
                      :placeholder="`${$t('other-branch-name')}`"
                      required
                    />
                  </div>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  gap: 10px;
                  align-items: center;
                "
              >
                <div class="input-field-title">{{ $t("select-report") }}</div>
                <div
                  @click="toggleTooltip"
                  @mouseover="showTooltip = true"
                  @mouseout="hideTooltip"
                  @focusout="hideTooltip"
                  tabindex="0"
                  style="position: relative; display: flex"
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.5 6.875C7.33424 6.875 7.17527 6.94085 7.05806 7.05806C6.94085 7.17527 6.875 7.33424 6.875 7.5V10C6.875 10.1658 6.94085 10.3247 7.05806 10.4419C7.17527 10.5592 7.33424 10.625 7.5 10.625C7.66576 10.625 7.82473 10.5592 7.94194 10.4419C8.05915 10.3247 8.125 10.1658 8.125 10V7.5C8.125 7.33424 8.05915 7.17527 7.94194 7.05806C7.82473 6.94085 7.66576 6.875 7.5 6.875ZM7.7375 4.425C7.58534 4.36249 7.41467 4.36249 7.2625 4.425C7.18578 4.45475 7.11569 4.49935 7.05625 4.55625C7.00105 4.617 6.95665 4.68676 6.925 4.7625C6.89001 4.83667 6.87289 4.91801 6.875 5C6.87453 5.08225 6.89029 5.16379 6.9214 5.23994C6.9525 5.31609 6.99833 5.38535 7.05625 5.44375C7.117 5.49896 7.18676 5.54335 7.2625 5.575C7.35719 5.6139 7.45998 5.62895 7.56184 5.61882C7.66371 5.60869 7.76152 5.5737 7.8467 5.51692C7.93187 5.46014 8.00179 5.3833 8.05032 5.29317C8.09885 5.20304 8.12449 5.10236 8.125 5C8.1227 4.83452 8.05796 4.67602 7.94375 4.55625C7.88431 4.49935 7.81422 4.45475 7.7375 4.425ZM7.5 1.25C6.26387 1.25 5.0555 1.61656 4.02769 2.30331C2.99988 2.99007 2.1988 3.96619 1.72576 5.10823C1.25271 6.25027 1.12894 7.50693 1.37009 8.71931C1.61125 9.9317 2.20651 11.0453 3.08059 11.9194C3.95466 12.7935 5.06831 13.3888 6.28069 13.6299C7.49307 13.8711 8.74974 13.7473 9.89177 13.2742C11.0338 12.8012 12.0099 12.0001 12.6967 10.9723C13.3834 9.94451 13.75 8.73613 13.75 7.5C13.75 6.67924 13.5883 5.86651 13.2743 5.10823C12.9602 4.34994 12.4998 3.66095 11.9194 3.08058C11.3391 2.50022 10.6501 2.03984 9.89177 1.72575C9.13349 1.41166 8.32076 1.25 7.5 1.25V1.25ZM7.5 12.5C6.5111 12.5 5.5444 12.2068 4.72215 11.6573C3.89991 11.1079 3.25904 10.327 2.88061 9.41342C2.50217 8.49979 2.40315 7.49445 2.59608 6.52455C2.789 5.55464 3.26521 4.66373 3.96447 3.96447C4.66373 3.2652 5.55465 2.789 6.52455 2.59607C7.49446 2.40315 8.49979 2.50216 9.41342 2.8806C10.3271 3.25904 11.1079 3.8999 11.6574 4.72215C12.2068 5.54439 12.5 6.51109 12.5 7.5C12.5 8.82608 11.9732 10.0979 11.0355 11.0355C10.0979 11.9732 8.82609 12.5 7.5 12.5V12.5Z"
                      fill="#04162D"
                    />
                  </svg>
                  <span v-if="showTooltip" class="tooltip">{{
                    workingHoursMessage
                  }}</span>
                </div>
              </div>
              <div
                v-if="
                  productVariant !== null
                    ? productVariant?.availableVariants?.product_options
                        ?.REPORT_COMPREHENSIVE &&
                      Object.prototype.hasOwnProperty.call(
                        productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE,
                        'NO_UPDATE'
                      )
                    : clickedSearchResult?.product_options
                        ?.REPORT_COMPREHENSIVE &&
                      Object.prototype.hasOwnProperty.call(
                        clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE,
                        'NO_UPDATE'
                      )
                "
                class="frame-35628"
                :title="
                  $t('last-updated') +
                  (productVariant !== null
                    ? productVariant?.availableVariants?.product_options
                        ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.report_dated
                    : clickedSearchResult?.product_options?.REPORT_COMPREHENSIVE
                        ?.NO_UPDATE?.report_dated) +
                  '.'
                "
              >
                <div class="frame-35664">
                  <input
                    type="radio"
                    id="NO_UPDATE"
                    class="rectangle-10"
                    :checked="selectedReportType === 'NO_UPDATE'"
                    @click="
                      selectReportType(
                        'NO_UPDATE',
                        productVariant !== null
                          ? productVariant?.availableVariants?.product_options
                              ?.REPORT_COMPREHENSIVE?.NO_UPDATE
                          : clickedSearchResult?.product_options
                              ?.REPORT_COMPREHENSIVE?.NO_UPDATE
                      )
                    "
                  />
                  <label for="NO_UPDATE" class="remember-me">
                    {{
                      productVariant?.availableVariants?.product_options
                        ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.report_label
                    }}
                    ({{ $t("updated") }}
                    {{
                      productVariant !== null
                        ? productVariant?.availableVariants?.product_options
                            ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.report_dated
                        : clickedSearchResult?.product_options
                            ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.report_dated
                    }})
                  </label>
                </div>
                <div class="in-25-min">
                  {{ $t("in") }}
                  {{
                    productVariant !== null
                      ? productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.eta_hours
                      : clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.eta_hours
                  }}
                  {{ $t("hr")
                  }}{{
                    productVariant !== null
                      ? productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.eta_hours > 1
                        ? $t("s")
                        : ""
                      : clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.eta_hours > 1
                      ? $t("s")
                      : ""
                  }}
                </div>
              </div>
              <div
                v-if="
                  productVariant !== null
                    ? productVariant?.availableVariants?.product_options
                        ?.REPORT_COMPREHENSIVE &&
                      Object.prototype.hasOwnProperty.call(
                        productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE,
                        'UPDATED'
                      )
                    : clickedSearchResult?.product_options
                        ?.REPORT_COMPREHENSIVE &&
                      Object.prototype.hasOwnProperty.call(
                        clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE,
                        'UPDATED'
                      )
                "
                class="frame-35628"
                :title="
                  $t('last-updated') +
                  (productVariant !== null
                    ? productVariant?.availableVariants?.product_options
                        ?.REPORT_COMPREHENSIVE?.UPDATED?.report_dated
                    : clickedSearchResult?.product_options?.REPORT_COMPREHENSIVE
                        ?.UPDATED?.report_dated) +
                  '.'
                "
              >
                <div class="frame-35664">
                  <input
                    type="radio"
                    id="updated"
                    class="rectangle-10"
                    :checked="selectedReportType === 'UPDATED'"
                    @click="
                      selectReportType(
                        'UPDATED',
                        productVariant !== null
                          ? productVariant?.availableVariants?.product_options
                              ?.REPORT_COMPREHENSIVE?.UPDATED
                          : clickedSearchResult?.product_options
                              ?.REPORT_COMPREHENSIVE?.UPDATED
                      )
                    "
                  />
                  <label for="updated" class="remember-me">
                    {{
                      productVariant?.availableVariants?.product_options
                        ?.REPORT_COMPREHENSIVE?.UPDATED?.report_label
                    }}
                    ({{ $t("updated") }}
                    {{
                      productVariant !== null
                        ? productVariant?.availableVariants?.product_options
                            ?.REPORT_COMPREHENSIVE?.UPDATED?.report_dated
                        : clickedSearchResult?.product_options
                            ?.REPORT_COMPREHENSIVE?.UPDATED?.report_dated
                    }})
                  </label>
                </div>
                <div class="in-25-min">
                  {{ $t("in") }}
                  {{
                    productVariant !== null
                      ? productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE?.UPDATED?.eta_hours
                      : clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE?.UPDATED?.eta_hours
                  }}
                  {{ $t("hr")
                  }}{{
                    productVariant !== null
                      ? productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE?.UPDATED?.eta_hours > 1
                        ? $t("s")
                        : ""
                      : clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE?.UPDATED?.eta_hours > 1
                      ? $t("s")
                      : ""
                  }}
                </div>
              </div>
              <div class="frame-35630" :title="`${$t('compiled')}`">
                <div class="frame-35664">
                  <input
                    type="radio"
                    id="fresh"
                    class="rectangle-10"
                    :checked="selectedReportType === 'FRESH'"
                    @click="
                      selectReportType(
                        'FRESH',
                        productVariant !== null
                          ? productVariant?.availableVariants?.product_options
                              ?.REPORT_COMPREHENSIVE?.FRESH
                          : clickedSearchResult?.product_options
                              ?.REPORT_COMPREHENSIVE?.FRESH
                      )
                    "
                  />
                  <label for="fresh" class="remember-me">{{
                    $t("fresh")
                  }}</label>
                </div>
                <div class="in-8-hrs">
                  {{ $t("in") }}
                  {{
                    productVariant !== null
                      ? productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE?.FRESH?.eta_hours
                      : clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE?.FRESH?.eta_hours
                  }}
                  {{ $t("hr")
                  }}{{
                    productVariant !== null
                      ? productVariant?.availableVariants?.product_options
                          ?.REPORT_COMPREHENSIVE?.FRESH?.eta_hours > 1
                        ? $t("s")
                        : ""
                      : clickedSearchResult?.product_options
                          ?.REPORT_COMPREHENSIVE?.FRESH?.eta_hours > 1
                      ? $t("s")
                      : ""
                  }}
                </div>
              </div>
              <div
                class="order-total"
                v-if="
                  userType == null || !userDetails?.includes('POSTPAID_ORDERS')
                "
              >
                <span>{{ $t("order-totla") }}</span>
                <div class="all-currency-wrapper">
                  <span class="currency-title">{{ $t("currency") }}</span>
                  <select v-model="selectedCurrency" class="currency-dropdown">
                    <option
                      v-for="currency in currencies"
                      :value="currency"
                      :key="currency.code"
                      class="country-option"
                    >
                      {{ currency.code.toUpperCase() }} - {{ currency.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="USD-wrapper"
                v-if="
                  userType == null || !userDetails?.includes('POSTPAID_ORDERS')
                "
              >
                <div class="USD" style="font-weight: 600">
                  <span
                    >{{ $t("total") }}
                    {{ selectedCurrency.code.toUpperCase() }}
                    <span
                      style="font-size: 12px; font-weight: 500"
                      v-if="selectedCurrency.code !== 'usd'"
                      >( 1$ = {{ convertedRate.toFixed(2) }}
                      {{ selectedCurrency.code.toUpperCase() }})</span
                    ></span
                  ><span> {{ convertedTotal?.toFixed(2) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="frame-35647">
          <div
            class="order-button"
            :style="{
              backgroundColor: userType == null ? createButtonColor : 'white',
              border: userType == null ? none : '2px solid #04162D',
              order: userType == null ? 2 : 1,
              padding: userType == null ? '16px 0px' : '14px 0px',
            }"
            :disabled="userType == null ? createButtonDisabled : none"
            v-on:click.prevent="handleButtonClick"
          >
            <div
              class="button-text"
              :style="{
                color: userType == null ? createButtonTextColor : '#04162D',
              }"
            >
              {{ userType !== null ? $t("checkout") : $t("create") }}
            </div>
          </div>
          <div
            class="order-button"
            :style="{
              backgroundColor: userType == null ? 'white' : '#046BE1',
              padding: userType == null ? '14px 0px' : '16px 0px',
              border: userType == null ? '2px solid #224096' : none,
              order: userType == null ? 1 : 2,
            }"
            :disabled="userType !== null ? createButtonDisabled : none"
            v-on:click.prevent="handleButtonClick1"
          >
            <div
              class="button-text"
              :style="{
                color: userType == null ? '#224096' : '#fff',
              }"
            >
              {{ userType !== null ? $t("to-cart") : $t("cancel") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toastify ref="toastContainer" />
  <OrderConfirmationModal
    v-if="showOrderConfirmationModal"
    :selectedCompanyName="orderInfo?.companyName"
    :reportDetails="orderInfo?.reportDetails"
    :userEmail="orderInfo?.userEmail"
    @close="hideOrderConfirmation()"
  />
</template>
<script>
import {
  CreateOrder,
  AllCountries,
  AllCurrencies,
  AddToCart,
  GetBranchList,
  UpdateUserDetails,
} from "@/api/APIs";
import VueCookies from "vue-cookies";
import LoaderAnimation from "@/assets/Animation/LoaderAnimation.vue";
import Toastify from "@/components/Toastify.vue";
import OrderConfirmationModal from "@/views/Modals/OrderConfirmation.vue";
import { mapActions, mapGetters } from "vuex";
import { Dropdown } from "floating-vue";
import "floating-vue/dist/style.css";

export default {
  name: "OrderDetails",
  beforeRouteLeave(to, from, next) {
    if (!this.isPiFlow) {
      sessionStorage.clear();
    }
    next();
  },
  components: {
    LoaderAnimation,
    Toastify,
    OrderConfirmationModal,
    Dropdown,
  },
  props: {},
  data() {
    return {
      workingHoursMessage: "",
      selectedReportType: "FRESH",
      isLoading: false,
      selectedReportDetails: {},
      countryId: "",
      name: "",
      email: VueCookies.get("email"),
      phone: "",
      additionalAddress: "",
      deliveryEmail: VueCookies.get("email"),
      confirmDeliveryEmail: "",
      referenceNumber: "",
      currencyValue: null,
      includeReferenceNumber: false,
      selectedCountry: JSON.parse(sessionStorage.getItem("selectedCountry")),
      selectedCountryCode: JSON.parse(
        sessionStorage.getItem("selectedCountry")
      ),
      landline: "",
      areaCode: "",
      countries: [],
      currencies: [],
      selectedCurrency: {
        id: 1,
        name: "US Dollar",
        code: "usd",
      },
      customertypes: [
        { name: "BANK" },
        { name: "IMPORTER" },
        { name: "EXPORTER" },
      ],
      selectedCustomerType: {},
      filteredCountries: [],
      showResultsFlag: false,
      windowWidth: window.innerWidth,
      userType: VueCookies.get("user-type")
        ? VueCookies.get("user-type")
        : null,
      showOrderConfirmationModal: false,
      orderInfo: null,
      shakeConfirmEmail: false,
      showTooltip: false,
      isMobile: window.innerWidth < 1023,
      clickedSearchResult: null,
      productVariant: null,
      selectedCompanyName: "",
      buttonStatus: "",
      branchList: null,
      BranchName: null,
      otherBranchName: null,
      entityType: VueCookies.get("EntityType") || null,
      previousRoute: null,
      fileKey: null,
    };
  },
  watch: {
    userType: {
      immediate: true,
      handler() {
        this.entityType = VueCookies.get("EntityType");
      },
    },
    workingHours: {
      immediate: true,
      handler(newMessage) {
        this.workingHoursMessage = newMessage;
      },
    },
  },
  created() {
    if (
      !sessionStorage.getItem("clickedSearchResult") ||
      !sessionStorage.getItem("productVariant") ||
      !sessionStorage.getItem("selectedCompanyName") ||
      !sessionStorage.getItem("selectedCountry") ||
      !sessionStorage.getItem("buttonStatus")
    ) {
      history.back();
    } else {
      this.clickedSearchResult = JSON.parse(
        sessionStorage.getItem("clickedSearchResult")
      );
      this.productVariant = JSON.parse(
        sessionStorage.getItem("productVariant")
      );
      this.previousRoute = JSON.parse(sessionStorage.getItem("previousRoute"));
      this.selectedCompanyName = sessionStorage.getItem("selectedCompanyName");
      this.selectedCountry = JSON.parse(
        sessionStorage.getItem("selectedCountry")
      );
      this.buttonStatus = sessionStorage.getItem("buttonStatus");
      this.additionalAddress =
        sessionStorage.getItem("selectedCompanyAddress") || "";
      this.phone =
        sessionStorage.getItem("selectedCompanyPhone") &&
        sessionStorage.getItem("selectedCompanyPhone") !== "null"
          ? sessionStorage.getItem("selectedCompanyPhone")
          : "";
      this.fileKey = sessionStorage.getItem("filePreviewUrl") || null;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    if (this.selectedReportType === "FRESH") {
      this.selectReportType(
        "FRESH",
        this.productVariant !== null
          ? this.productVariant?.availableVariants?.product_options
              ?.REPORT_COMPREHENSIVE?.FRESH
          : this.clickedSearchResult?.product_options?.REPORT_COMPREHENSIVE
              ?.FRESH
      );
    }
    this.fetchCountryList();
    this.fetchCurrenciesList();
    this.fetchAPIData();
    if (VueCookies.get("EntityType") === "BANK") {
      this.BranchesList();
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapGetters(["userDetails"]),
    workingHours() {
      const options = { hour: "numeric", minute: "numeric", hour12: true };
      const event = new Date(Date.UTC(2024, 1, 30, 3, 30, 0));
      const event2 = new Date(Date.UTC(2024, 1, 30, 15, 30, 0));
      const formattedEvent = event.toLocaleString("en-US", options);
      const formattedEvent2 = event2.toLocaleString("en-US", options);
      return `${this.$t("working-hr")} ${formattedEvent} ${this.$t(
        "to"
      )} ${formattedEvent2} ${this.$t("time-zone")}.`;
    },
    isPiFlow() {
      if (this.previousRoute == "/pi-order") {
        return true;
      }
      return false;
    },
    userTokenAvailable() {
      return this.$root.userToken !== null;
    },
    convertedTotal() {
      const orderTotalUSD = this.getOrderTotal();

      if (this.selectedCurrency?.code === "usd") {
        return orderTotalUSD;
      } else {
        const conversionRate = this.currencyValue[this.selectedCurrency?.code];
        return orderTotalUSD * conversionRate;
      }
    },
    convertedRate() {
      const orderTotalUSD = this.getOrderTotal();

      if (this.selectedCurrency?.code === "usd") {
        return orderTotalUSD;
      } else {
        const conversionRate = this.currencyValue[this.selectedCurrency?.code];
        return conversionRate;
      }
    },
    createButtonDisabled() {
      return !(
        this.selectedCountry?.name &&
        this.isValidPhoneNumber(this.phone) &&
        this.isValidEmail(this.deliveryEmail) &&
        this.isValidEmail(this.confirmDeliveryEmail)
      );
    },
    toggleConfirmDeliveryEmail() {
      return (
        this.isValidEmail(this.deliveryEmail) ==
        this.isValidEmail(this.confirmDeliveryEmail)
      );
    },
    toggleConfirmDeliveryEmailBorder() {
      return this.toggleConfirmDeliveryEmail
        ? "1px solid #57575780"
        : "1px solid #D20D3B";
    },
    addToCartColor() {
      return this.createButtonDisabled ? "#9b98984d" : "white";
    },
    createButtonColor() {
      return this.createButtonDisabled ? "#90b8fa" : "#046BE1";
    },
    createButtonTextColor() {
      return this.createButtonDisabled ? "#fff" : "#fff";
    },
  },
  methods: {
    ...mapActions(["updateCartCount"]),
    async BranchesList() {
      try {
        const response = await GetBranchList(VueCookies.get("entityId"));
        if (response) {
          if (response.message !== "No branches found for given entityId !!!") {
            this.branchList = response?.allBranches;
            if (VueCookies.get("branch")) {
              const entityId = Number(VueCookies.get("branch"));
              const MatchingBranchName = response.allBranches?.find(
                (entry) => entry.id === entityId
              );
              this.BranchName = MatchingBranchName.branchName;
            }
          }
        } else {
          this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    goBack() {
      if (this.previousRoute) {
        this.$router.push(this.previousRoute);
      } else {
        this.$router.go(-1);
      }
    },
    goBackToSearch() {
      this.$router.push("/search");
    },
    handleButtonClick() {
      if (this.userType !== null) {
        this.CartCheckout();
      } else if (this.createButtonDisabled) {
        this.shakeConfirmDelivery();
      } else {
        this.placeOrder();
      }
    },
    handleButtonClick1() {
      if (this.userType !== null) {
        this.AddToCart(false);
      } else {
        this.goBack();
      }
    },
    async CartCheckout() {
      await this.AddToCart(true);
      // this.hideOrderDetailsModal();
    },
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    hideTooltip() {
      this.showTooltip = false;
    },
    shakeConfirmDelivery() {
      if (this.deliveryEmail && !this.confirmDeliveryEmail) {
        this.shakeConfirmEmail = true;
        setTimeout(() => {
          this.shakeConfirmEmail = false;
        }, 500);
        return;
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    toggleCustomerTypeDropdown() {
      this.$refs.customerTypeDropdown.focus();
    },
    isWindows() {
      return /Windows/.test(window.navigator.userAgent);
    },
    daysDifference(dateString) {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "short", day: "2-digit" };
      return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
    },
    isValidPhoneNumber(phone) {
      if (phone !== "") {
        return phone.length > 7;
      } else {
        return true;
      }
    },
    isValidEmail(email) {
      return email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    showToast() {
      return this.$refs.toastContainer.addToast(
        "Please fill all the mandatory fields to place an order.",
        { type: "error" }
      );
    },
    async fetchAPIData() {
      try {
        const response = await fetch(
          "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json"
        );
        if (response.ok) {
          const data = await response.json();
          this.currencyValue = data.usd;
        } else {
          console.error("Failed to fetch API data:", response.statusText);
        }
      } catch (error) {
        console.error("Error occurred while fetching API data:", error);
      }
    },
    getOrderTotal() {
      if (this.selectedReportType === "FRESH") {
        if (this.productVariant !== null) {
          return this.productVariant?.availableVariants?.product_options
            ?.REPORT_COMPREHENSIVE?.FRESH?.purchase_usd;
        } else {
          return this.clickedSearchResult?.product_options?.REPORT_COMPREHENSIVE
            ?.FRESH?.purchase_usd;
        }
      } else if (this.selectedReportType === "NO_UPDATE") {
        if (this.productVariant !== null) {
          return this.productVariant?.availableVariants?.product_options
            ?.REPORT_COMPREHENSIVE?.NO_UPDATE?.purchase_usd;
        } else {
          return this.clickedSearchResult?.product_options?.REPORT_COMPREHENSIVE
            ?.NO_UPDATE?.purchase_usd;
        }
      } else if (this.selectedReportType === "UPDATED") {
        if (this.productVariant !== null) {
          return this.productVariant?.availableVariants?.product_options
            ?.REPORT_COMPREHENSIVE?.UPDATED?.purchase_usd;
        } else {
          return this.clickedSearchResult?.product_options?.REPORT_COMPREHENSIVE
            ?.UPDATED?.purchase_usd;
        }
      }
      return "";
    },
    selectReportType(type, selectedReport) {
      this.selectedReportType = type;
      this.selectedReportDetails = selectedReport;
    },
    getFirstDialCode(dialCodeString) {
      if (dialCodeString) {
        return dialCodeString.split(",")[0];
      }
    },
    formatPhoneNumber() {
      this.phone = this.phone.replace(/\D/g, "");
    },
    async fetchCountryList() {
      try {
        const response = await AllCountries(false, false);
        this.countries = await response.allCountries;
      } catch (error) {
        this.loginError = "Error occurred during login.";
        console.error(error);
      }
    },
    async fetchCurrenciesList() {
      try {
        const response = await AllCurrencies();
        this.currencies = await response.allCurrencies;
      } catch (error) {
        this.loginError = "Error occurred during login.";
        console.error(error);
      }
    },
    filterCountries() {
      this.showResultsFlag = true;
      this.filteredCountries = this.countries.filter((country) =>
        country.name.toLowerCase().includes(this.selectedCountry?.name)
      );
    },
    selectCountry(country) {
      this.selectedCountry = country;
      this.filteredCountries = [];
    },
    showResults() {
      this.showResultsFlag = true;
      this.filteredCountries = this.countries;
      document.addEventListener("click", this.closeResultsOnClickOutside);
    },
    closeResultsOnClickOutside(event) {
      const searchInput = this.$refs.searchInput;
      const countryResults = this.$refs.countryResults;
      if (
        searchInput &&
        !searchInput.contains(event.target) &&
        countryResults &&
        !countryResults.contains(event.target)
      ) {
        this.showResultsFlag = false;
        document.removeEventListener("click", this.closeResultsOnClickOutside);
      }
    },
    async updateBranch() {
      const payload = {};
      let matchingBranch = null;
      if (VueCookies.get("entityId")) {
        matchingBranch = this.branchList?.find(
          (branch) => branch.branchName === this.BranchName
        );
        if (matchingBranch) {
          payload.entityBranch = matchingBranch.id;
        }
        if (this.email) {
          payload.email = this.email;
        }
      }
      try {
        const response = await UpdateUserDetails(payload);
        if (response.message == "SUCCESS") {
          if (VueCookies.get("entityId")) {
            VueCookies.set("branch", matchingBranch.id);
          }
        } else {
          console.error("Something went wrong. Please try again later");
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          console.error("Error updating user details:", error);
        }
      }
    },
    async AddToCart(checkout) {
      this.isLoading = true;
      const firstDialCode = this.getFirstDialCode(
        this.selectedCountryCode?.dialCode
      );

      const phoneNumberLengths =
        this.selectedCountryCode && this.selectedCountryCode?.phoneLength
          ? this.selectedCountryCode?.phoneLength
              .split(",")
              .map((length) => parseInt(length.trim()))
          : [];
      if (
        !this.isPiFlow &&
        this.phone !== "" &&
        !phoneNumberLengths.includes(this.phone.length)
      ) {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast(
          `Phone number length should be ${this.selectedCountryCode?.phoneLength} digits`,
          { type: "error" }
        );
      }
      if (this.landline !== "" && this.areaCode === "") {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast(
          "Please enter the area code for the provided landline number.",
          { type: "error" }
        );
      }
      if (
        VueCookies.get("EntityType") === "BANK" &&
        this.BranchName === "Other" &&
        !this.otherBranchName
      ) {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast(
          "Please enter the other branch name.",
          { type: "error" }
        );
      }
      if (VueCookies.get("EntityType") === "BANK" && !this.BranchName) {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast("Please select the branch.", {
          type: "error",
        });
      }
      if (
        VueCookies.get("EntityType") === "BANK" &&
        !VueCookies.get("branch") &&
        this.BranchName
      ) {
        this.updateBranch();
      }
      if (this.referenceNumber && this.referenceNumber.trim().length > 0) {
        this.includeReferenceNumber = true;
      }
      const phoneNo = this.isPiFlow
        ? this.phone
        : this.phone !== ""
        ? `+${firstDialCode}-${this.phone}`
        : "";
      const fullLandline =
        this.landline !== "" ? `${this.areaCode}-${this.landline}` : "";

      try {
        let address =
          this.clickedSearchResult?.additional_info?.business_address ||
          this.clickedSearchResult?.additional_info?.company_address ||
          this.productVariant?.availableAddresses?.[0]?.registered_address
            ?.full_address;
        if (!address) {
          address = "-";
        }
        // const hasClickedSearchResultAddress =
        //   this.clickedSearchResult?.additional_info?.business_address ||
        //   this.clickedSearchResult?.additional_info?.company_address;

        // if (hasClickedSearchResultAddress && this.additionalAddress == "") {
        //   this.additionalAddress =
        //     this.productVariant?.availableAddresses?.[0]?.registered_address?.full_address;
        // }
        const payload = {
          order: {
            ...(this.fileKey && {piFileKey: this.fileKey}),
            subjectName: this.selectedCompanyName,
            ...(this.clickedSearchResult?.additional_info
              ?.other_company_name && {
              otherCompanyName:
                this.clickedSearchResult?.additional_info?.other_company_name,
            }),
            subjectAddress: address,
            subjectCountry: this.selectedCountry?.id,
            orderEmail: this.deliveryEmail,
            orderContactNumber: phoneNo,
            orderLandlineNumber: fullLandline,
            reportType: this.selectedReportType,
            reportDetails: this.selectedReportDetails,
            customerName: this.name,
            referenceNumber: this.referenceNumber,
            includeReferenceNumber: this.includeReferenceNumber,
            customerType: this.selectedCustomerType?.name,
            currencyId: this.selectedCurrency?.id,
            reportManual: false,
            ...(VueCookies.get("EntityType") === "BANK" && {
              misCommentsBranch:
                this.BranchName === "Other"
                  ? this.otherBranchName
                  : this.BranchName,
            }),
            ...(this.clickedSearchResult?.additional_info
              ?.registered_address && {
              registeredAddress:
                this.clickedSearchResult?.additional_info?.registered_address,
            }),
            ...(!this.clickedSearchResult?.additional_info
              ?.registered_address &&
              this.productVariant?.availableAddresses?.[0]?.registered_address
                ?.full_address && {
                registeredAddress:
                  this.productVariant?.availableAddresses?.[0]
                    ?.registered_address?.full_address,
              }),
            ...(this.clickedSearchResult?.additional_info?.more_addresses && {
              moreAddresses:
                this.clickedSearchResult?.additional_info?.more_addresses,
            }),
            addressByCustomer: this.additionalAddress,
            ...(this.clickedSearchResult?.additional_info
              ?.company_identifiers?.[0].value && {
              subjectCompanyId:
                this.selectedCountry?.id == 44
                  ? this.clickedSearchResult.additional_info
                      .company_identifiers[0].unmasked
                  : this.clickedSearchResult.additional_info
                      .company_identifiers[0].value,
            }),
          },
        };
        // If It's Pi flow send Order Referer
        if (this.isPiFlow) {
          payload.order.orderReferrer = "PI";
        } 
        const response = await AddToCart(payload);
        if (response && response.message == "Added to cart") {
          this.isLoading = false;
          this.updateCartCount(response.cartSize);
          if (checkout) {
            this.$root.toggleCheckout();
          } else {
            // this.hideOrderDetailsModal();
            this.$root.toggleCheckoutTooltip();
            this.goBackToSearch();
          }
        } else {
          this.isLoading = false;
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
      this.isLoading = false;
    },
    async placeOrder() {
      this.isLoading = true;
      const firstDialCode = this.getFirstDialCode(
        this.selectedCountryCode?.dialCode
      );

      const phoneNumberLengths =
        this.selectedCountryCode && this.selectedCountryCode.phoneLength
          ? this.selectedCountryCode.phoneLength
              .split(",")
              .map((length) => parseInt(length.trim()))
          : [];

      if (this.deliveryEmail !== this.confirmDeliveryEmail) {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast(
          "Delivery email and confirm email do not match.",
          { type: "error" }
        );
      }
      if (
        !this.isPiFlow &&
        this.phone !== "" &&
        !phoneNumberLengths.includes(this.phone.length)
      ) {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast(
          `Phone number length should be ${this.selectedCountryCode?.phoneLength} digits`,
          { type: "error" }
        );
      }
      if (this.landline !== "" && this.areaCode === "") {
        this.isLoading = false;
        return this.$refs.toastContainer.addToast(
          "Please enter the area code for the provided landline number.",
          { type: "error" }
        );
      }
      if (this.referenceNumber && this.referenceNumber.trim().length > 0) {
        this.includeReferenceNumber = true;
      }
      const phoneNo = this.isPiFlow
        ? this.phone
        : this.phone !== ""
        ? `+${firstDialCode}-${this.phone}`
        : "";
      const fullLandline =
        this.landline !== "" ? `${this.areaCode}-${this.landline}` : "";
      let response = null;
      try {
        let address =
          this.clickedSearchResult?.additional_info?.business_address ||
          this.clickedSearchResult?.additional_info?.company_address;
        if (!address) {
          address = "-";
        }
        const payload = {
          ...(this.fileKey && {piFileKey: this.fileKey}),
          subjectName: this.selectedCompanyName,
          ...(this.clickedSearchResult?.additional_info?.other_company_name && {
            otherCompanyName:
              this.clickedSearchResult?.additional_info?.other_company_name,
          }),
          subjectAddress: address,
          subjectCountry: this.selectedCountry?.id,
          orderEmail: this.deliveryEmail,
          orderContactNumber: phoneNo,
          orderLandlineNumber: fullLandline,
          reportType: this.selectedReportType,
          reportDetails: this.selectedReportDetails,
          customerName: this.name,
          referenceNumber: this.referenceNumber,
          includeReferenceNumber: this.includeReferenceNumber,
          customerType: this.selectedCustomerType?.name,
          currencyId: this.selectedCurrency?.id,
          reportManual: false,
          ...(VueCookies.get("EntityType") === "BANK" && {
            misCommentsBranch:
              this.BranchName === "Other"
                ? this.otherBranchName
                : this.BranchName,
          }),
          ...(this.clickedSearchResult?.additional_info?.registered_address && {
            registeredAddress:
              this.clickedSearchResult?.additional_info?.registered_address,
          }),
          ...(!this.clickedSearchResult?.additional_info?.registered_address &&
            this.productVariant?.availableAddresses?.[0]?.registered_address
              ?.full_address && {
              registeredAddress:
                this.productVariant?.availableAddresses?.[0]?.registered_address
                  ?.full_address,
            }),
          ...(this.clickedSearchResult?.additional_info?.more_addresses && {
            moreAddresses:
              this.clickedSearchResult?.additional_info?.more_addresses,
          }),
          addressByCustomer: this.additionalAddress,
          ...(this.clickedSearchResult?.additional_info
            ?.company_identifiers?.[0].value && {
            subjectCompanyId:
              this.selectedCountry?.id == 44
                ? this.clickedSearchResult.additional_info
                    .company_identifiers[0].unmasked
                : this.clickedSearchResult.additional_info
                    .company_identifiers[0].value,
          }),
        };
        response = await CreateOrder(payload);
        if (response && response.message == "SUCCESS") {
          if (response?.result?.paymentRequired === true) {
            window.location.href = response?.result?.paymentLink;
          } else {
            const userEmail = VueCookies.get("user");
            this.orderInfo = {
              companyName: this.selectedCompanyName,
              reportDetails: this.selectedReportDetails,
              userEmail,
            };
            this.isLoading = false;
            this.showOrderConfirmationModal = true;
            return;
          }
          // this.viewOrderConfirmationModal();
          // this.hideOrderDetailsModal();
        } else {
          this.isLoading = false;
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } finally {
        if (!response?.result?.paymentRequired) {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
      }
      // this.$root.hideLoader();
    },
    hideOrderConfirmation() {
      this.showOrderConfirmationModal = false;
      this.goBackToSearch();
      // this.hideOrderDetailsModal();
    },
  },
};
</script>
<style scoped>
.bg {
  /* background: rgba(0, 0, 0, 8%); */
  display: flex;
  align-items: center;
  justify-content: center;
  /* backdrop-filter: blur(10px); */
  /* z-index: 9999; */
  width: auto;
  box-shadow: none;
  height: calc(100vh - 55px);
}
.bg-guest {
  height: calc(100vh - 93px);
}
.logged-in {
  margin-left: 18vw;
  padding-top: 55px;
  transition: margin-left 0.3s ease;
}
.logged-in.collapsed {
  margin-left: 60px;
}
.logged-in.notification {
  padding-top: 105px !important;
  height: calc(100vh - 105px);
}
.not-logged-in {
  width: 100%;
}
.flag-image {
  width: 20px;
  height: 15px;
}
.modal {
  background: #f2f5f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  /* overflow: scroll; */
  width: 100%;
  height: 100%;
}
.loader-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.your-order-details-here {
  color: var(--dark-blue, #224096);
  text-align: left;
  padding: 10px 0;
  font-family: "Figtree";
  font-size: 24px;
  font-weight: 700;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #224096;
}
.frame-35654 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0 0 0;
  align-items: flex-start;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  background: #f2f8ff;
  height: -webkit-fill-available;
  /* overflow-y: auto;
  overflow-x: hidden;
  height: fit-content;
  height: 695px; */
}
.wrapper-class-2 {
  display: grid;
  flex-direction: row;
  align-items: flex-start;
  padding: 0 40px;
  gap: 20px;
  grid-template-columns: repeat(2, 1fr);
}
.wrapper-class {
  display: flex;
  flex-direction: column;
  /* width: 50%; */
  gap: 20px;
  /* padding: 0 40px; */
  margin-top:20px;
}
.company-info-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  align-self: stretch;
}
.frame-35656 {
  display: grid;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  width: -webkit-fill-available;
  padding: 10px;
  grid-template-columns: repeat(2, 1fr);
}
.frame-35655 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.company-name {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.yoki-biodiesel-private-limited {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  text-transform: capitalize;
}
.frame-356562 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.report-tyoe {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.fresh-report {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
}
.frame-35657 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.delivery-time {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
._8-hours {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
}
.frame-35658 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.country {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.india {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
}
.frame-35659 {
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.cin-identifiers {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.dropdown-1 {
  padding: 10px;
  height: 37.5px !important;
  border: 1px solid rgba(87, 87, 87, 0.5);
  border-radius: 13px;
  height: auto !important;
  box-shadow: none;
  margin: 0;
  width: -webkit-fill-available;
  outline: none;
}
.u-24299-mh-2021-ptv-372774 {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
}
.frame-356572 {
  display: grid;
  gap: 24px;
  align-items: flex-start;
  justify-content: center;
  padding: 10px;
  position: relative;
  width: -webkit-fill-available;
  flex-wrap: wrap;
  grid-template-columns: repeat(2, 1fr);
}
.frame-35660 {
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.status {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.active {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  text-transform: capitalize;
}
.frame-35661 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.is-listed {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.false {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
}
.frame-35663 {
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.year-of-incorporation {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
._2021 {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
}
.frame-35662 {
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.classification {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
  align-self: stretch;
}
.private-limited-company {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  text-transform: capitalize;
}
.lock-note {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 13px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  text-transform: capitalize;
}
.lock-note {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 13px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  text-transform: capitalize;
}
.default-tooltip-message {
  color: var(--text-mid, #3e4855);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  padding: 2px 8px;
}
.locked {
  position: relative;
}
.locked .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(226 225 225 / 40%);
  -webkit-backdrop-filter: blur(3.5px);
  backdrop-filter: blur(3.5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-radius: 5px;
}
.locked .lock-icon {
  font-size: 15px;
  color: gray;
}
.locked span {
  z-index: 2;
  position: relative;
}
.input-sections {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 49%;
  align-self: stretch;
  flex-shrink: 0;
}
.phone-input {
  flex-direction: row !important;
  justify-content: space-between !important;
  background-color: white !important;
  border: 1px solid rgba(87, 87, 87, 0.5) !important;
  border-radius: 14px !important;
}
.input-sections1 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  width: 49%;
}
.input-field-title {
  font-size: 14px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
  width: 100%;
}
.frame-35653 {
  /* background: #ceeaeb; */
  background: white;
  border-radius: 24px;
  padding: 15px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* flex-shrink: 0; */
  width: -webkit-fill-available;
  box-shadow: rgb(255, 255, 255) -4px -4px 8px 0px,
    rgba(0, 0, 0, 0.25) 4px 4px 8px 0px;
  position: relative;
  /* margin: 0 40px; */
  margin-top: 20px;
}
.frame-35652 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.frame-35627 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.select-your-report {
  color: var(--text-dark, #04162d);
  text-align: center;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  position: relative;
}
.frame-35628 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.frame-35664 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
  width: 75%;
}
.in-25-min {
  color: var(--text-dark, #04162d);
  text-align: center;
  font-family: "Figtree-Italic";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  font-style: true;
  position: relative;
}
.frame-35629 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.in-4-hrs {
  color: var(--text-dark, #04162d);
  text-align: center;
  font-family: "Figtree-Italic";
  font-size: 16px;
  line-height: 150%;
  font-weight: 400;
  font-style: true;
  position: relative;
}
.frame-35630 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.in-8-hrs {
  color: var(--text-dark, #04162d);
  text-align: center;
  font-family: "Figtree-Italic";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  font-style: true;
  position: relative;
}
.frame-35647 {
  position:fixed;
  width:-webkit-fill-available;
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding: 15px 40px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  background: white;
  bottom: 0;
  box-shadow: 0px -5px 36px 0px rgba(17, 54, 90, 0.08);
}
.button-instance {
  background: var(--main-color, #046BE1) !important;
  padding: 17px 24px 17px 24px !important;
  align-self: stretch !important;
}
.button-instance2 {
  padding: 17px 24px 17px 24px !important;
  align-self: stretch !important;
}
.ref-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  box-sizing: border-box;
}
.frame-3 {
  background: #ffffff;
  border-radius: 13px !important;
  border: 1px solid rgba(87, 87, 87, 0.5);
  display: flex;
  flex-direction: row;
  gap: 100px;
  align-items: center;
  justify-content: center;
  /* flex-shrink: 0; */
  width: 100%;
  position: relative;
  overflow: hidden;
}
.enter-email-address {
  color: #3e4855;
  text-align: left;
  font-family: "Figtree";
  /* font-size: 14px; */
  font-weight: 400;
  position: relative;
  border-radius: 13px;
  border: none;
  outline: none;
  padding: 10px 17px 10px 17px;
  width: 100%;
  height: auto;
  box-shadow: none;
  margin: 0;
  cursor: pointer;
  align-self: stretch;
}
.rectangle-10 {
  background: #ffffff;
  border-radius: 50%;
  border-style: solid;
  border-color: #18c3df;
  border-width: 2px;
  /* flex-shrink: 0; */
  width: 18px;
  height: 18px;
  position: relative;
  cursor: pointer;
}
/* .rectangle-10:checked {
  background-color: #18c3df;
  border-color: #18c3df;
} */
/* .rectangle-10:checked:after {
  content: "\25CB";
  color: white;
  border-radius: 50%;
  border: 3px solid white;
  font-weight: 800;
  font-size: 8px;
  line-height: 18px;
  position: absolute;
  left: 50%;
  top: 42%;
  transform: translate(-50%, -50%);
} */
/* .rectangle-10:checked::before {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
} */

.rectangle-10:focus {
  outline: none;
}
.remember-me {
  color: var(--text-dark, #04162d);
  text-align: left;
  font-family: "Figtree";
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
}
.order-button {
  border-radius: 13px;
  padding: 16px 0px 16px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* flex-shrink: 0; */
  /* min-width: 150px; */
  width: -webkit-fill-available;
  cursor: pointer;
}
.button-text {
  /* color: #ffffff; */
  text-align: center;
  font-family: "NunitoSans-SemiBold", sans-serif;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
}
.input-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.input-group1 {
  display: flex;
  flex-direction: column;
  width: 49%;
  box-sizing: border-box;
}
.input-group input,
.input-group1 input,
.input-group select,
.input-group textarea {
  padding: 10px;
  border: 1px solid rgba(87, 87, 87, 0.5);
  border-radius: 13px;
  height: auto !important;
  box-shadow: none;
  margin: 0;
  width: -webkit-fill-available;
  outline: none;
}
.country-results {
  width: 100%;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  background-color: white;
  border-radius: 15px;
  overflow-y: auto;
  top: 100%;
  z-index: 9999;
  box-shadow: 0px 16px 16px 0px rgba(20, 45, 77, 0.1);
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.country-results div {
  width: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  padding: 5px 0 5px 20px;
  text-align: left;
  font-size: 14px;
}
.country-results div:hover {
  background-color: #dee9f2;
}
.user-details-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.user-details-wrapper-address {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.country-dropdown {
  width: 35% !important;
  outline: none;
  border: none !important;
  height: 27.22px;
}
.deliver-to {
  font-size: 14px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
  /* height: 24px; */
}
.order-total {
  font-size: 16px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.USD-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 20px;
}
.USD {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 500;
  font-family: "Figtree";
}
.currency-title {
  font-size: 14px;
  font-weight: 500;
  font-family: "Figtree";
}
.all-currency-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
  gap: 15px;
}
.currency-dropdown {
  width: 22% !important;
  outline: none;
  border: 1px solid rgba(87, 87, 87, 0.5);
  border-radius: 13px;
  padding: 0 10px;
  height: 27.22px;
}
#address-field {
  height: 100%;
}
.tooltip {
  position: absolute;
  background-color: #585858;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  top: 20px;
  right: right -20px;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 2;
  font-size: 11.5px;
  font-weight: 500;
  font-family: Arial;
  box-shadow: 0px 16px 16px 0px rgba(20, 45, 77, 0.1);
}
.notes {
  border-radius: 16px;
  background: white;
  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
}
.note-title {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: "Figtree";
  text-align: left;
  gap: 7px;
  font-weight: 500;
  font-size: small;
  margin: 10px;
}
.note-text {
  text-align: left;
  padding-left: 5px;
  font-family: "Figtree";
  font-size: 13px;
  line-height: 150%;
}
.back-button {
  /* padding-left: 10px; */
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  color: #224096;
  padding: 10px;
  /* border: 1px solid #224096; */
  border-radius: 14px;
  opacity: 0.7;
}
.back-button:hover {
  opacity: 1;
}
ul {
  background: transparent;
}
.modal-notloggedin {
    margin-top:6rem;
  }

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
}

.shake {
  animation: shake 0.5s;
}

@media only screen and (max-width: 767px) {
  .bg {
    /* margin-top: 1.2rem; */
    height: calc(100vh - 71.34px);
    margin-left:0;
  }
  .bg-guest {
    height: calc(100vh - 71.34px);
  }
  .modal {
    width: 100%;
    height: auto;
  }
  #address-field {
    height: 50px;
  }
  .notes {
    border-radius: 8px;
  }
  .note-title {
    font-size: 12px;
  }
  .frame-35654 {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    max-height: calc(100vh - 71.34px);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0;
  }
  .back-button {
    font-size: 14px;
    margin-top: 10px;
  }
  .company-info-wrapper {
    flex-direction: column;
    width: 100%;
  }
  .frame-35653 {
    width: -webkit-fill-available;
    padding: 15px;
    margin: 0 15px;
  }
  .frame-35656,
  .frame-356572 {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
    padding: 5px 0 5px 0;
  }
  .user-details-wrapper {
    flex-direction: column;
    gap: 10px;
  }
  .user-details-wrapper:nth-of-type(4) {
    flex-direction: column;
    gap: 10px !important;
  }
  .ref-wrapper,
  .input-group1 {
    width: 100% !important;
  }
  .in-25-min,
  .in-8-hrs {
    font-size: 13px;
    font-family: "Figtree" !important;
  }
  .your-order-details-here:nth-child(1) svg {
    width: 25px;
    height: 25px;
  }
  .your-order-details-here div {
    font-size: 14px !important;
    font-family: "Figtree";
  }
  .your-order-details-here div:first-child {
    margin-left: 20px !important;
  }
  .your-order-details-here div:last-child {
    margin-right: 20px !important;
  }
  .your-order-details-here {
    margin-bottom: 10px;
    padding: 5px 0;
  }
  .country,
  .india,
  .yoki-biodiesel-private-limited,
  .company-name,
  .classification,
  .private-limited-company,
  .status,
  .active,
  .is-listed,
  .false,
  .year-of-incorporation,
  ._2021,
  .enter-email-address,
  .input-group input,
  .cin-identifiers,
  .u-24299-mh-2021-ptv-372774,
  .remember-me,
  .select-your-report,
  .input-group1 input,
  .currency-title,
  .deliver-to,
  .country-results div {
    font-size: 14px !important;
    font-family: "Figtree" !important;
  }
  .input-group1 input {
    padding: 5px;
    border-radius: 8px;
  }
  .phone-input {
    border-radius: 8px !important;
    overflow: hidden;
  }
  .frame-3 {
    border-radius: 12px !important;
  }
  .input-group input,
  .currency-dropdown,
  .enter-email-address {
    padding: 5px;
    border-radius: 8px;
  }
  .user-details-wrapper-address {
    flex-direction: column;
    gap: 10px;
  }
  .wrapper-class-2 {
    padding: 0;
    gap: 20px;
    grid-template-columns: repeat(1, 1fr);
  }
  .wrapper-class {
    gap: 10px;
    padding: 0 15px;
  }
  /* .back-button {
    padding-left: 0;
  } */
  .lock-note,
  .lock-note {
    font-size: 12px;
  }
  .input-sections,
  .input-sections1 {
    width: 100%;
  }
  .input-group select {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }
  .input-group1,
  .ref-wrapper {
    gap: 10 !important;
  }
  .order-total span,
  .USD span {
    font-size: 14px;
  }
  .order-total {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .currency-dropdown {
    font-size: 12px;
  }
  .frame-35647 {
    padding: 15px;
    gap: 15px;
  }
  /* .order-button {
    padding: 10px 0px !important;
  } */
  .button-text {
    font-size: 14px;
  }
  .all-currency-wrapper {
    width: 100%;
    justify-content: space-between;
  }
  .frame-35664 {
    width: 65%;
  }
  .frame-35664 label {
    text-align: left;
    font-size: 13px !important;
  }
}
@media only screen and (min-width: 1156px) and (max-width: 1220px) {
  .bg-guest {
    height: calc(100vh - 73px);
  }
}
@media only screen and (min-width: 1022px) and (max-width: 1156px) {
  .bg-guest {
    height: calc(100vh - 73px) !important;

  }
}
@media only screen and (min-width: 768px) and (max-width: 1022px) {
  .bg {
    height: calc(100vh - 55px);
    margin-left:0;
  }
  .bg-guest {
    height: calc(100vh - 79.61px);
  }
  .company-info-wrapper {
    flex-direction: column;
    /* width: 40%; */
  }
  .frame-35656 {
    grid-template-columns: repeat(2, 1fr);
  }
  .frame-356572 {
    grid-template-columns: repeat(1, 1fr);
  }
  .note-title {
    font-size: 16px;
  }
  .frame-35654 {
    max-height: calc(100vh - 65px);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
}
@media only screen and (min-width: 1156px) {
  /* .modal {
    height: auto;
  } */
  .modal-notloggedin {
    height: -webkit-fill-available;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1022px) {
  .bg {
    height: calc(100vh - 79.61px);
  }
  .frame-35654 {
    max-height: calc(100vh - 89.61px);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
}
</style>
